// Copyright (c) 2022 WiseTime. All rights reserved.

import { Notification } from "../../../generated/wisetime/user/notification/v4/notification_pb"

export const prepareAllNotifications = (
  generalNotifications: Notification.AsObject[],
  siteNotifications: Notification.AsObject[]
): Notification.AsObject[] => (
  generalNotifications.concat(siteNotifications)
    .sort((a: Notification.AsObject, b: Notification.AsObject) => {
      const aCreateTime = a?.createTime?.seconds || 0
      const bCreateTime = b?.createTime?.seconds || 0
      return bCreateTime - aCreateTime
    })
)
